import { Category } from '../models';

export function GetLeafCategoryId(breadcrumbs: Category[]) {
  const leafCategory = breadcrumbs[breadcrumbs.length - 1];

  // TODO: remove coalescing operator after adding proper breadcrumbs
  // property in offer.component.spec.ts
  return leafCategory?.id ?? '';
}
